import { useEffect, useState } from "react";
import Pagination from "./Pagination";
import NcImage from "componentsTemplate/NcImage/NcImage";
import perfilService from "../../services/PerfilService";
import ButtonPrimary from "componentsTemplate/Button/ButtonPrimary";
import { Icon } from "@mui/material";
import { Search } from "@mui/icons-material";
import { showToastSuccess } from "utils/toasts";

const TableContact = ({
  coluna1 = "Coluna 1",
  coluna2 = "Coluna 2",
  coluna3 = "Coluna 3",
  coluna4 = "Coluna 4",
  rota = "",
  acao = null,
}: any) => {
  const [pagination, setPagination]: any = useState(null);
  const [lista, setLista]: any = useState([]);
  const [search, setSearch] = useState("");

  const urlBaseApi = process.env.REACT_APP_BACKEND_API_URL;

  const [centeredModal, setCenteredModal] = useState(false);
  const [dadosContato, setDadosContato]: any = useState(null);

  useEffect(() => {
    if (rota != "") {
      buscarInfo();
    }
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      buscarInfo(1, 10, search);
    }, 500);
    return () => clearTimeout(timer);
  }, [search]);

  const buscarInfo = async (current_page = 1, per_page = 20, search = "") => {
    await perfilService
      .getList(rota, current_page, per_page, search)
      .then((list: any) => {
        setLista(list.data.data);
        setPagination({
          last_page: list.data.last_page,
          current_page: list.data.current_page,
          per_page: list.data.per_page,
        });
      })
      .catch((error: any) => {
        console.error(error);
      });
  };

  const formatarDataParaBR = (data: string) => {
    let dataFormatada = new Date(data);

    let dataString = dataFormatada.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    // let horaString = dataFormatada.toLocaleTimeString('pt-BR', {
    //   hour: '2-digit',
    //   minute: '2-digit'
    // });

    return `${dataString}`;
  };

  const exibirData = (item: any) => {
    return formatarDataParaBR(item.created_at);
  };

  const exibirImg = (item: any) => {
    return (
      <NcImage
        containerClassName="flex-shrink-0 h-12 w-12 rounded-lg relative z-0 overflow-hidden lg:h-14 lg:w-14"
        src={
          item.logo_path != null
            ? urlBaseApi +
              "/storage/images/posts/events/logos/" +
              item.logo_path
            : "https://images.unsplash.com/photo-1617059063772-34532796cdb5?ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwyfHx8ZW58MHx8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=60"
        }
        fill
        sizes="80px"
        alt="post"
      />
    );
  };

  const exibirStatus = (post_type_id: any) => {
    if (post_type_id == 1) {
      return (
        <span className="px-2 inline-flex text-xs leading-5 font-medium rounded-full bg-green-100 text-green-800 lg:text-sm">
          Dicas
        </span>
      );
    } else if (post_type_id == 2) {
      return (
        <span className="px-2 inline-flex text-xs leading-5 font-medium rounded-full bg-yellow-100 text-green-800 lg:text-sm">
          Eventos
        </span>
      );
    } else if (post_type_id == 3) {
      return (
        <span className="px-2 inline-flex text-xs leading-5 font-medium rounded-full bg-red-100 text-green-800 lg:text-sm">
          Banners
        </span>
      );
    } else if (post_type_id == 4) {
      return (
        <span className="px-2 inline-flex text-xs leading-5 font-medium rounded-full bg-blue-100 text-green-800 lg:text-sm">
          Classificados
        </span>
      );
    } else if (post_type_id == 5) {
      return (
        <span className="px-2 inline-flex text-xs leading-5 font-medium rounded-full bg-indigo-100 text-green-800 lg:text-sm">
          Parceiros
        </span>
      );
    }
  };

  const getPostName = (post_type_id: any, post: any) => {
    
    if (post_type_id == 1) {
      return (
        <span>
          {post?.tip?.name ?? '-'}
        </span>
      );
    } else if (post_type_id == 2) {
      return (
        <span>
          {post?.event?.name ?? '-'}
        </span>
      );
    } else if (post_type_id == 3) {
      return (
        <span>
          {post?.banner?.name ?? '-'}
        </span>
      );
    } else if (post_type_id == 4) {
      return (
        <span>
          {post?.classified?.name ?? '-'}
        </span>
      );
    } else if (post_type_id == 5) {
      return (
        <span>
          {post?.partnership?.name ?? '-'}
        </span>
      );
    }
  };

  const CarregaModal = (row: any) => {
    setDadosContato(row);
    setCenteredModal(!centeredModal);
  };

  const acaoVoltar = (status: any) => {
    setCenteredModal(status);
    setDadosContato(null);
  };

  const handleDelete = async (id: any) => {
    await perfilService.removeContact(id).then(() => {
      buscarInfo();

      showToastSuccess("Contato removido com sucesso!");
    });
  }

  return (
    <>
      {dadosContato != null ? (
        <>
          <div className="rounded-xl md:border md:border-neutral-100 dark:border-neutral-800 md:p-6">
            <div className="flex-end">
              <ButtonPrimary
                className="md:col-span-2"
                type="button"
                onClick={() => acaoVoltar(false)}
              >
                Voltar
              </ButtonPrimary>
            </div>
            <div className="row mt-1">
              <div className="col-12 col-lg-9">
                {dadosContato !== null ? (
                  <>
                    <h2 className="mb-0">
                      Dados do contato: {dadosContato.user.name}
                    </h2>
                    <br />
                    <ul className="list-unstyled ms-1">
                      <li className="mb-75 ms-1">
                        <span className="fw-bolder" id="name">
                          Tipo : {exibirStatus(dadosContato?.post_type_id)}
                        </span>
                        <br></br>
                      </li>
                      <li className="mb-75 ms-1">
                        <span className="fw-bolder" id="name">
                          Mensagem : {dadosContato.comment}
                        </span>
                        <br></br>
                      </li>
                      <li className="mb-75 ms-1">
                        <span className="fw-bolder" id="name">
                          E-mail : {dadosContato.user.email}
                        </span>
                        <br></br>
                      </li>
                      <li className="mb-75 ms-1">
                        <span className="fw-bolder" id="name">
                          Celular : {dadosContato.user.phone}
                        </span>
                        <br></br>
                      </li>

                      <li className="mb-75  ms-1">
                        <span className="fw-bolder me-25">
                          Data: {exibirData(dadosContato)}{" "}
                        </span>
                        <br></br>
                      </li>
                    </ul>
                  </>
                ) : null}
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="flex-end mb-6">
            <div className="flex border rounded-full h-11 w-full md:w-1/2 justify-between">
              <input
                className="rounded-l-full bg-transparent w-full outline-none border-transparent focus:outline-none focus:ring-0 focus:border-transparent"
                maxLength={42}
                placeholder="Procurar por..."
                onChange={(e) => setSearch(e.target.value)}
                value={search}
              />
              <div className="flex my-auto mx-2 justify-center items-center h-8 w-9 bg-primary-600 rounded-full shadow-md">
                <Icon className="text-white" component={Search} fontSize="medium" />
              </div>
            </div>
          </div>

          <div className="flex flex-col space-y-8">
            <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="py-2 align-middle inline-block min-w-full px-1 sm:px-6 lg:px-8">
                <div className="shadow dark:border dark:border-neutral-800 overflow-hidden sm:rounded-lg">
                  <table className="min-w-full divide-y divide-neutral-200 dark:divide-neutral-800">
                    <thead className="bg-neutral-50 dark:bg-neutral-800">
                      <tr className="text-left text-xs font-medium text-neutral-500 dark:text-neutral-300 uppercase tracking-wider">
                        <th scope="col" className="px-2 sm:px-4 lg:px-6 py-3 min-w-0">
                          <div className="truncate">{coluna1}</div>
                        </th>
                        <th scope="col" className="px-2 sm:px-4 lg:px-6 py-3 min-w-0">
                          <div className="truncate">{coluna2}</div>
                        </th>
                        <th scope="col" className="px-2 sm:px-4 lg:px-6 py-3 min-w-0 hidden sm:table-cell">
                          <div className="truncate">{coluna3}</div>
                        </th>
                        <th scope="col" className="px-2 sm:px-4 lg:px-6 py-3 min-w-0 hidden md:table-cell">
                          <div className="truncate">{coluna4}</div>
                        </th>
                        <th scope="col" className="px-2 sm:px-4 lg:px-6 py-3 min-w-0">
                          <div className="truncate">Ação</div>
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white dark:bg-neutral-900 divide-y divide-neutral-200 dark:divide-neutral-800">
                      {lista.map((item: any) => (
                        <tr key={item.id}>
                          <td className="px-2 sm:px-4 lg:px-6 py-4 min-w-0 max-w-0 w-1/4">
                            <div className="truncate text-sm">
                              {getPostName(item?.post_type_id, item?.post)}
                            </div>
                          </td>
                          <td className="px-2 sm:px-4 lg:px-6 py-4 min-w-0 max-w-0 w-1/3">
                            <div className="flex items-center overflow-hidden">
                              <div className="flex-grow min-w-0">
                                <h2 className="text-sm font-semibold dark:text-neutral-300 truncate">
                                  {item.user.name}
                                </h2>
                              </div>
                            </div>
                          </td>
                          <td className="px-2 sm:px-4 lg:px-6 py-4 min-w-0 hidden sm:table-cell">
                            <div className="flex justify-start">
                              {exibirStatus(item?.post_type_id)}
                            </div>
                          </td>
                          <td className="px-2 sm:px-4 lg:px-6 py-4 min-w-0 text-sm text-neutral-500 dark:text-neutral-400 hidden md:table-cell">
                            <div className="truncate">
                              {exibirData(item)}
                            </div>
                          </td>
                          <td className="px-2 sm:px-4 lg:px-6 py-4 min-w-0 text-sm font-medium text-neutral-300">
                            <div className="flex flex-col sm:flex-row sm:space-x-2 space-y-1 sm:space-y-0">
                              <span
                                className="text-primary-800 dark:text-primary-500 hover:text-primary-900 cursor-pointer text-xs sm:text-sm"
                                onClick={() => CarregaModal(item)}
                              >
                                Acessar
                              </span>
                              <span
                                onClick={() => handleDelete(item.id)}
                                className="text-rose-600 hover:text-rose-900 cursor-pointer text-xs sm:text-sm"
                              >
                                Apagar
                              </span>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {pagination != null ? (
              <Pagination pagination={pagination} buscarInfo={buscarInfo} />
            ) : null}
          </div>
        </>
      )}
    </>
  );
};

export default TableContact;
